import { asyncComponent } from 'react-async-component';
import {ProjectsSkeleton} from './ProjectsSkeleton'

export const Projects = asyncComponent({
  resolve: () => import(/* webpackChunkName: 'Projects' */ './Projects'),
  LoadingComponent: ProjectsSkeleton
});
